import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

const TOKEN_KEY = "spannr_token";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (password !== confirm) {
      toast.error("Passwords don't match");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      localStorage.setItem(TOKEN_KEY, data.access_token);
      toast.success("Password reset — you're signed in");
      // Force a full reload so AuthProvider picks up the new token
      window.location.href = `/suppliers/dashboard/${data.user.supplier_id}`;
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Reset failed — link may be expired");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16">
      <div className="text-xs font-mono-tech tracking-[0.25em] text-[#FF5100] mb-2">
        SUPPLIERS · RECOVERY
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold leading-none mb-6 text-neutral-900">
        Set a new password.
      </h1>
      <form onSubmit={submit} data-testid="reset-form" className="border border-neutral-200 bg-neutral-50 p-6 space-y-4">
        <Field label="New password">
          <input
            data-testid="reset-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="At least 6 characters"
            className="w-full bg-white border border-neutral-200 focus:border-[#FF5100] outline-none px-3 h-11 text-sm"
          />
        </Field>
        <Field label="Confirm password">
          <input
            data-testid="reset-confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="w-full bg-white border border-neutral-200 focus:border-[#FF5100] outline-none px-3 h-11 text-sm"
          />
        </Field>
        <button
          type="submit"
          data-testid="reset-submit"
          disabled={busy}
          className="w-full px-6 h-11 bg-[#FF5100] hover:bg-[#E64A00] disabled:opacity-50 text-white font-bold uppercase tracking-wider text-xs transition-colors"
        >
          {busy ? "Saving..." : "Save & sign in"}
        </button>
        <div className="text-center text-xs text-neutral-500 pt-2 border-t border-neutral-200">
          <Link to="/login" className="text-[#FF5100] hover:underline">Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-[0.2em] font-mono-tech text-neutral-500 mb-1.5">{label}</div>
      {children}
    </label>
  );
}
